// extracted by mini-css-extract-plugin
module.exports = {"mobile-header-container":"NavigationMobile_mobile-header-container_19UWg"};